import { render, staticRenderFns } from "./AdminLogs.vue?vue&type=template&id=b4d8aab0&scoped=true&"
import script from "./AdminLogs.vue?vue&type=script&lang=js&"
export * from "./AdminLogs.vue?vue&type=script&lang=js&"
import style0 from "./AdminLogs.vue?vue&type=style&index=0&id=b4d8aab0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d8aab0",
  null
  
)

export default component.exports